<template>
  <div>
    <el-card class="mat12" v-if="!name">
      <el-row>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.projectCode">
          <h4 class="flex_shrink">项目编号：</h4>
          <span class="ellipsis">{{dataDesc.projectCode}}</span>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.name"  :title="dataDesc.name">
          <h4 class="flex_shrink">项目名称：</h4>
          <span class="ellipsis">{{dataDesc.name}}</span>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.companyName">
          <h4 class="flex_shrink">所属公司：</h4>
          <span class="ellipsis">{{dataDesc.companyName}}</span>
        </el-col>
        <el-col
          :span="6"
          class="media_col padding-tb10 flex_class address_wrap"
          v-if="dataDesc.address"
        >
          <h4 class="flex_shrink">项目地址：</h4>
          <div @click="handleOpenAddress" class="ellipsis" :title="dataDesc.address">
            <span :class="{'ellipsis':$store.state.tagView}">{{dataDesc.address}}</span>
            <i class="el-icon-location"></i>
          </div>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.source">
          <h4 class="flex_shrink">项目来源：</h4>
          <span class="ellipsis">{{dataDesc.source}}</span>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.customerCompany" :title="dataDesc.customerCompany">
          <h4 class="flex_shrink">客户单位名称：</h4>
          <span class="ellipsis">{{dataDesc.customerCompany}}</span>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.customerName">
          <h4 class="flex_shrink">客户联系人：</h4>
          <span class="ellipsis">{{dataDesc.customerName}}</span>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.customerPhone" :title="dataDesc.customerPhone">
          <h4 class="flex_shrink">客户联系人电话：</h4>
          <span class="ellipsis">{{dataDesc.customerPhone}}</span>
        </el-col>
        <el-col :span="6" class="padding-tb10 flex_class media_col" >
          <h4 class="flex_shrink">管理公司：</h4>
          <div class="start_icon ellipsis">
            <span class="ellipsis" :title="dataDesc.manageCompanyName">{{ dataDesc.manageCompanyName}}</span>
          </div>
        </el-col>
          <el-col :span="6" class="padding-tb10 flex_class media_col"  >
          <h4 class="flex_shrink">合同公司：</h4>
          <div class="start_icon ellipsis">
            <span class="ellipsis"  :title="dataDesc.contractCompanyName">{{ dataDesc.contractCompanyName}}</span>
          </div>
        </el-col>

        <div class="clearfix">
          <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.deptName">
            <h4 class="flex_shrink">所属部门：</h4>
            <span class="ellipsis">{{dataDesc.deptName}}</span>
          </el-col>
          <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.createName">
            <h4 class="flex_shrink">立项人：</h4>
            <span class="ellipsis">{{dataDesc.createName}}</span>
          </el-col>
        </div>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.saleName">
          <h4 class="flex_shrink">主要联系人：</h4>
          <span class="ellipsis">{{dataDesc.saleName}}</span>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.leader">
          <h4 class="flex_shrink">分管领导：</h4>
          <span class="ellipsis">{{dataDesc.leader}}</span>
        </el-col>
        <el-col
          :span="6"
          class="media_col padding-tb10 flex_class"
          v-if="dataDesc.saleName && item.name"
          v-for="item in participantsList"
          :key="item.id"
        >
          <h4 class="flex_shrink">{{item.title}}：</h4>
          <span :class="{'ellipsis':$store.state.tagView}" class="white_space">{{item.name}}</span>
        </el-col>
      </el-row>
      <el-row class="media_col padding-tb10 " v-if="dataDesc.customerRemark" style="width:100%">
        <h4 class="flex_shrink">客户需求：</h4>
        <span :class="{'ellipsis':$store.state.tagView}">{{dataDesc.customerRemark}}</span>
      </el-row>
      <!-- 针对进程来写的 -->
       <el-row v-if="isProcess">
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.startupDate">
          <h4 class="flex_shrink">初次洽谈时间：</h4>
          <span :class="{'ellipsis':$store.state.tagView}">{{dataDesc.startupDate}}</span>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.intentionTime">
          <h4 class="flex_shrink">意向时间：</h4>
          <span :class="{'ellipsis':$store.state.tagView}">{{dataDesc.intentionTime}}</span>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.createDate">
          <h4 class="flex_shrink">项目创建时间：</h4>
          <span :class="{'ellipsis':$store.state.tagView}">{{dataDesc.createDate}}</span>
        </el-col>
      </el-row>
    </el-card>

    <!-- 地图弹窗 -->
    <map-ready-dialog
      @cancel="handleCncel"
      :dialogVisible="dialogVisible"
      :center="center"
      :address="dataDesc.address"
    ></map-ready-dialog>
  </div>
</template>

<script>

export default {
  name: 'CardApprovalInfo',
  props: {
    dataDesc: {
      type: Object,
      default: () => {}
    },
    name: {
      type: String,
      default: ''
    },
    isProcess: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      center: {
        lng: '',
        lat: ''
      },
      participantsList: [], // 处理结构
    }
  },
  created () {
    this.center.lng = this.dataDesc.lng
    this.center.lat = this.dataDesc.lat
    this.handleParticipantsList()
  },

  methods: {
    // 处理下参与人的问题
    handleParticipantsList () {
      this.$nextTick(() => {
        if (this.dataDesc.participants) {
          let list = []
          this.dataDesc.participants.forEach(item => {
            let newItem = list.find((i) => i.roleType == item.roleType)
            if (!newItem) {
              list.push({
                roleType: item.roleType,
                users: [item.userName]
              })
            } else {
              newItem.users.push(item.userName)
            }
          })

          this.participantsList = list.map(item => {
             if (item.roleType === 0) {
              item.title = '项目负责人'
            }
            else if (item.roleType === 1) {
              item.title = '市场'
            }
            else if (item.roleType === 2) {
              item.title = '运营'
            }
            else if (item.roleType === 3) {
              item.title = '综合服务人员'
            }
            else if (item.roleType === 4) {
              item.title = '其他人员'
            } else{
              item.title = '其他人员'
            }
            item.name = item.users.join()
            return item
          })
        }
      })
    },
    // 展示地图
    handleOpenAddress () {
      this.dialogVisible = true
      // this.center.lng = this.dataDesc.lng;
      // this.center.lat = this.dataDesc.lat;
      // this.center.lng = this.dataDesc.lng;
      // this.center.lat = this.dataDesc.lat;
    },
    // 取消关闭弹窗
    handleCncel (val) {
      this.dialogVisible = val
    }
  }
}
</script>

<style lang="scss" scoped>
$color: #409eff;
.contrast {
  color: $color;
}
.view_history {
  cursor: pointer;
  margin-left: 10px;
}
.address_wrap {
  cursor: pointer;
  i {
    color: $color;
  }
}
.white_space{
  white-space: nowrap
}
</style>
